import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { API_DATE_FORMAT } from '../../constant/base.constant';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-date',
  templateUrl: './fpx-date.component.html',
  styleUrls: ['./fpx-date.component.scss'],
  providers : [
    {
       provide : NG_VALUE_ACCESSOR,
       useExisting : forwardRef(() => FpxDateComponent),
       multi : true
    }
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FpxDateComponent extends BaseFpxControlComponent {

  @Input() selectedDate!: Date | null;
  @Input() inputDisabled: boolean = true;
  @Input() toggleDisabled: boolean = false;
  @Input() minDate: string | undefined;
  @Input() maxDate: string | undefined;

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer,changeDetectorRef)
   }
   
  protected override customWriteValue(obj: any): void {
    if (obj) {
      this.selectedDate = new Date(obj);
      const formattedDate = moment(this.selectedDate).format(API_DATE_FORMAT);
      this.formControl.setValue(formattedDate, {
        emitEvent: false,
        emitModelToViewChange: false,
      });
    } else {
      this.selectedDate = null;
    }
  }

  onDatechange(): void {
    const formattedDate = moment(this.selectedDate).format(API_DATE_FORMAT);
    this.formControl.setValue(formattedDate);
    // this.onChange(formattedDate);
    this.onTouched();
  }



}
